module.exports = __webpack_public_path__ + "static/media/feeds.073d9e61.png";